interface SensData {
  x: number[];
  y: number[];
}
export interface SensitivityResultInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.NPV'?: SensData;
 'RESULTS.DATA.ECONOMIC_METRICS.IRR'?: SensData;
 'RESULTS.DATA.ECONOMIC_METRICS.PP'?: SensData;
 'PRODUCTS.BIOGAS'?: SensData;
 'PRODUCTS.BIOMETHANE'?: SensData;
 'PRODUCTS.ELECTRICITY'?: SensData;
}
export class SensitivityResult {
  'RESULTS.DATA.ECONOMIC_METRICS.NPV';
  'RESULTS.DATA.ECONOMIC_METRICS.IRR';
  'RESULTS.DATA.ECONOMIC_METRICS.PP';
  'PRODUCTS.BIOGAS';
  'PRODUCTS.BIOMETHANE';
  'PRODUCTS.ELECTRICITY';
  constructor(param: SensitivityResultInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.NPV'] = param['RESULTS.DATA.ECONOMIC_METRICS.NPV'];
    this['RESULTS.DATA.ECONOMIC_METRICS.IRR'] = param['RESULTS.DATA.ECONOMIC_METRICS.IRR'];
    this['RESULTS.DATA.ECONOMIC_METRICS.PP'] = param['RESULTS.DATA.ECONOMIC_METRICS.PP'];
    this['PRODUCTS.BIOGAS'] = param['PRODUCTS.BIOGAS'];
    this['PRODUCTS.BIOMETHANE'] = param['PRODUCTS.BIOMETHANE'];
    this['PRODUCTS.ELECTRICITY'] = param['PRODUCTS.ELECTRICITY'];
  }
}


export interface SensitivityResultsInterface {
  'SENSITIVITY~VERSION'?;
  'SENSITIVITY~RESULT~CURRENCY'?;
  'RESULTS~DATA~CREATED'?;
  [key:string]: SensitivityResult;
}
